import { Component, Input, OnInit } from '@angular/core';
import { TicketDto, TicketModeEnum } from '../../../service/dto';
import { Router } from '@angular/router';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
	selector: 'app-ticket-search-modal',
	standalone: false,
	templateUrl: './ticket-search-modal.component.html',
	styleUrl: './ticket-search-modal.component.scss'
})
export class TicketSearchModalComponent implements OnInit{
	@Input() searchPhrase!: string;
	@Input() mode!: TicketModeEnum;
	@Input() tickets?: TicketDto[];
	showPolicyColumn=false;

	constructor(private router: Router, private modalRef: NzModalRef) { }

	ngOnInit(): void {
		this.showPolicyColumn = !this.tickets ? false : this.tickets.filter(item => item.policy).length > 0;
	}
	openTicket(ticket: TicketDto) {
		this.router.navigate(['/ticket', ticket.ticketMode, ticket.id]);
		this.modalRef.destroy();
	}
}
